// extracted by mini-css-extract-plugin
module.exports = {"CreateAccountConfirmation_service":"CreateAccountConfirmation_CreateAccountConfirmation_service__Jwxit"};